<template>
  <div class="flex flex-col gap-xs p-s">
    <div class="flex gap-xs items-center overflow-x-auto no-scrollbar">
      <template v-for="index in 5" :key="index">
        <Skeleton class="h-8 w-32 rounded-lg" />
      </template>
    </div>
    <div class="flex flex-col gap-2xs">
      <Skeleton class="w-36 h-2" />
      <div class="flex flex-col items-center w-full">
        <div v-for="i in 10" :key="i" class="flex items-center w-full gap-xs py-xs pl-2xs pr-m">
          <Skeleton class="w-6 h-6 rounded-full" />
          <div class="flex-1 flex flex-col gap-3xs">
            <Skeleton class="w-full h-4" />
            <Skeleton class="w-20 h-2" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex px-s py-[28px] rounded-b-lg bg-moss-500">
    <Skeleton class="w-36 h-9" />
  </div>
</template>
